import styled from 'styled-components';

export const Wrapper = styled.div`
    height: 100vh;
    overflow: auto;
`;
